import { Fade } from 'react-awesome-reveal';
import { useSelector } from 'react-redux';
import Banner from '../banner/McoBanner';
import SectionMenu from '../section-menu/SectionMenu';
import { getMCOMenuItems } from '../view/utils';
import { useMemo } from 'react';

const McoSystem = (props) => {
  const { roleId } = useSelector((state) => state?.Auth?.userClaimObject);
  const { selectedView, componentAccessList } = props;

  const sectionMenuItems = useMemo(
    () => getMCOMenuItems(selectedView, componentAccessList, roleId),
    [selectedView, componentAccessList, roleId]
  );

  const filteredMenuItems = sectionMenuItems
    .filter((section) => section.shouldRender)
    .map(({ shouldRender, ...rest }) => rest);

  return (
    <div>
      <Fade>
        <Banner data={selectedView} />
      </Fade>

      <SectionMenu
        data={selectedView}
        role={roleId}
        menuItems={filteredMenuItems}
      />

      {filteredMenuItems.map((section, index) => {
        const isOdd = index % 2 === 0;
        return (
          <Fade key={section.key}>
            <div
              style={{ marginBottom: '1em' }}
              className={isOdd ? 'full-width-in-container light-grey' : ''}>
              {section.component}
            </div>
          </Fade>
        );
      })}
    </div>
  );
};

export default McoSystem;
